<template>
    <div class="page_index">
        <div class="scroll_ist flex" :style="itemStyle">
            <div class="scoll_warp" :style="`animation-duration:${animationDuration}s`">
                <ul>
                    <li v-for="(item,index) in rankList" :key="index" :style="isLeft(index)">
                        <div class="flex flex_sb page_list">
                            <div class="page_name">{{item.name || '暂无'}}</div>
                            <div class="page_price">
                                <div class="page_num">{{item.price}}</div>
                                <div>元/{{item.unitName}}</div>
                            </div>  
                            <div class="page_title">{{item.supplierName || '暂无'}}</div>
                        </div>
                        <!-- 数组的最后一条不显示边框线 -->
                        <!-- {{isShow && index === rankList.length -1}}22 -->
                        <div class="page_line"></div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        fontVh
    } from "@/assets/js/common";

    export default {
        name: 'articleList',
        props: { 
            rankList: {
                type: Array,
                default: () => []
            },
            unit: {
                type: String,
                default: ''
            },
            uniIdx: {
                type: [Number, String],
                default: 1
            },
            // 用于改变数组列表单独一列文字靠左对齐
            active: {
                type: Number,
                default: -1
            },
            scrollHeight: {
                type: String,
                default: ''
            },
            scrollItemHeight: {
                type: String,
                default: ''
            },
            isStep: { // 是否滚动
                type: Boolean,
                default: false
            },
            speed: {
                type: Number,
                default: 0.3
            }
        },
        data() {
            return {}
        },
        components: {},
        created() {},
        computed: {
            supplierName() {
                return function(name) {
                    if (!name) return '暂无'
                    let arr = [];
                    let index = 0;
                    while (index < name.length) {
                        arr.push(name.slice(index, index += 6));
                    }
                    return arr
                }
            },
            animationDuration() {
                if (this.rankList.length >= 11) {
                    return this.rankList.length * 2.5
                }
                return 0
            },
            itemStyle() {
                const {
                    scrollHeight
                } = this
                return `height:${fontVh(scrollHeight)};`
            },
            isLeft() {
                return (idx) => {
                    return `text-align:${this.active != idx ? 'center' : 'left'};`
                }
            }
        },
        watch: {},
        methods: {}
    }
</script>

<style lang='scss' scoped>
    @keyframes scroll-up {
        0% {
            transform: translateY(0);
            /* 文本初始位置，向上偏移 0 */
        }

        100% {
            transform: translateY(-100%);
            /* 文本最终位置，向上偏移 100%（等于滚动区域高度） */
        }
    }

    .page_index {
        word-break: break-all;
        overflow: hidden;
        padding: 0 vh(20);
        display: flex;
        justify-content: center;

        .scroll_ist {
            overflow: hidden;

            &.flex {
                align-items: flex-start;
            }

            .scroll_header {
                margin: vh(8) 0 vh(14) 0;
                @include flex();
                @include font(16, $list_color, center);

                >div {
                    position: relative;
                    padding: 0 vh(10);
                }
            }

            .scoll_warp {
                overflow: hidden;
                animation-name: scroll-up;
                animation-duration: 0;
                animation-timing-function: linear;
                animation-iteration-count: infinite;
                // animation: scroll-up 22.5s linear infinite;

                /* 动画名称、持续时间、缓动函数和重复次数 */
                ul {
                    li {
                        span {
                            padding: 0 vh(10);
                            word-break: break-all;
                        }

                        div {
                            text-align: left;
                            justify-content: space-between;
                        }

                        .page_border {
                            margin: 0 vh(10);
                            border: vh(1) dashed #27c5ff;
                        }

                        .page_list {
                            padding: vh(10) 0;
                            text-align: center;

                            .page_name {
                                width: 20%;
                                @include font(24, #ffffff);
                                font-weight: bold;
                            }

                            .page_price {
                                @include font(20, #ffffff, center);

                                .page_num {
                                    @include font(24, #00ccff, center);
                                    font-weight: bold;
                                    // margin-top: vh(10);
                                }
                            }

                            .page_title {
                                width: 40%;
                                display: flex;
                                // justify-content: center;
                                // align-items: center;
                                // height: vh(58);
                                // margin-top: vh(10);
                                @include font(22, #00ccff);
                                font-weight: bold;
                                // padding: vh(5) 0 vh(20) 0;
                            }
                        }

                        .page_line {
                            width: 90%;
                            height: vh(1);
                            margin: 0 auto;
                            background: linear-gradient(to right,
                                    #00048f 0%,
                                    #00558b 10%,
                                    #00558b 20%,
                                    #00558b 30%,
                                    #00558b 40%,
                                    #00558b 50%,
                                    #00558b 60%,
                                    #00558b 70%,
                                    #00558b 80%,
                                    #00558b 90%,
                                    #00048f 100%);
                        }
                    }
                }
            }
        }
    }
</style>